/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FetchCallRequest } from '../models/FetchCallRequest';
import type { FlowView } from '../models/FlowView';
import type { GlobalFlowSerializerWithRepr } from '../models/GlobalFlowSerializerWithRepr';
import type { PaginatedAccountAttributesList } from '../models/PaginatedAccountAttributesList';
import type { PaginatedFlowViewList } from '../models/PaginatedFlowViewList';
import type { PaginatedGlobalFlowSerializerWithReprList } from '../models/PaginatedGlobalFlowSerializerWithReprList';
import type { PatchedGlobalFlowSerializerWithRepr } from '../models/PatchedGlobalFlowSerializerWithRepr';
import type { PostOmniMessage } from '../models/PostOmniMessage';
import type { TemplateValidation } from '../models/TemplateValidation';
import type { TemplateValidationResponse } from '../models/TemplateValidationResponse';
import type { TriggerCallRequest } from '../models/TriggerCallRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FlowsService {
    /**
     * @returns PaginatedFlowViewList
     * @throws ApiError
     */
    public static flowsList({
        applicationType,
        betaVersion,
        campaignUuid,
        channelConfig,
        complianceType,
        createdAt,
        createdBy,
        dashboardConfig,
        debtCollectionsUsecase,
        deletedBy,
        demoConfig,
        demoLeads,
        deployedVersion,
        documentation,
        excludeFields,
        experimentEnabled,
        experimentPlatformConfig,
        experimentVersion,
        experimentVersions,
        fields,
        forDemo,
        industrySegmentType,
        isLlm,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        misReportsJson,
        name,
        offset,
        ordering,
        organisation,
        organisationName,
        organisationUuidIn,
        pdfGenerationTemplate,
        readDepth,
        search,
        status,
        subscriptionId,
        tags,
        tcnAllowedCampaignCollectorTypes,
        tcnScheduleTemplateId,
        templateFlow,
        templateFlowUuidIn,
        templateType,
        thumbnail,
        type,
        useBeta,
        useCase,
        uuid,
    }: {
        applicationType?: Array<string>,
        betaVersion?: Array<string>,
        campaignUuid?: Array<string>,
        channelConfig?: Array<string>,
        complianceType?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        dashboardConfig?: Array<string>,
        debtCollectionsUsecase?: Array<string>,
        deletedBy?: Array<string>,
        demoConfig?: Array<string>,
        demoLeads?: Array<string>,
        deployedVersion?: Array<string>,
        documentation?: Array<string>,
        excludeFields?: Array<string>,
        experimentEnabled?: Array<string>,
        experimentPlatformConfig?: Array<string>,
        experimentVersion?: Array<string>,
        experimentVersions?: Array<string>,
        fields?: Array<string>,
        forDemo?: Array<string>,
        industrySegmentType?: Array<string>,
        isLlm?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        misReportsJson?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        organisation?: Array<string>,
        organisationName?: Array<string>,
        organisationUuidIn?: Array<string>,
        pdfGenerationTemplate?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        subscriptionId?: Array<string>,
        tags?: Array<string>,
        tcnAllowedCampaignCollectorTypes?: Array<string>,
        tcnScheduleTemplateId?: Array<string>,
        templateFlow?: Array<string>,
        templateFlowUuidIn?: Array<string>,
        templateType?: Array<string>,
        thumbnail?: Array<string>,
        type?: Array<string>,
        useBeta?: Array<string>,
        useCase?: Array<string>,
        uuid?: Array<string>,
    }): CancelablePromise<PaginatedFlowViewList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/flows/',
            query: {
                'application_type': applicationType,
                'beta_version': betaVersion,
                'campaign_uuid': campaignUuid,
                'channel_config': channelConfig,
                'compliance_type': complianceType,
                'created_at': createdAt,
                'created_by': createdBy,
                'dashboard_config': dashboardConfig,
                'debt_collections_usecase': debtCollectionsUsecase,
                'deleted_by': deletedBy,
                'demo_config': demoConfig,
                'demo_leads': demoLeads,
                'deployed_version': deployedVersion,
                'documentation': documentation,
                'exclude-fields': excludeFields,
                'experiment_enabled': experimentEnabled,
                'experiment_platform_config': experimentPlatformConfig,
                'experiment_version': experimentVersion,
                'experiment_versions': experimentVersions,
                'fields': fields,
                'for_demo': forDemo,
                'industry_segment_type': industrySegmentType,
                'is_llm': isLlm,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'mis_reports_json': misReportsJson,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'organisation': organisation,
                'organisation__name': organisationName,
                'organisation__uuid__in': organisationUuidIn,
                'pdf_generation_template': pdfGenerationTemplate,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'subscription_id': subscriptionId,
                'tags': tags,
                'tcn_allowed_campaign_collector_types': tcnAllowedCampaignCollectorTypes,
                'tcn_schedule_template_id': tcnScheduleTemplateId,
                'template_flow': templateFlow,
                'template_flow__uuid__in': templateFlowUuidIn,
                'template_type': templateType,
                'thumbnail': thumbnail,
                'type': type,
                'use_beta': useBeta,
                'use_case': useCase,
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns GlobalFlowSerializerWithRepr
     * @throws ApiError
     */
    public static flowsCreate({
        requestBody,
    }: {
        requestBody: GlobalFlowSerializerWithRepr,
    }): CancelablePromise<GlobalFlowSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/flows/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedGlobalFlowSerializerWithReprList
     * @throws ApiError
     */
    public static flowBulkUpdate({
        requestBody,
        applicationType,
        betaVersion,
        campaignUuid,
        channelConfig,
        complianceType,
        createdAt,
        createdBy,
        dashboardConfig,
        debtCollectionsUsecase,
        deletedBy,
        demoConfig,
        demoLeads,
        deployedVersion,
        documentation,
        excludeFields,
        experimentEnabled,
        experimentPlatformConfig,
        experimentVersion,
        experimentVersions,
        fields,
        forDemo,
        industrySegmentType,
        isLlm,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        misReportsJson,
        name,
        offset,
        ordering,
        organisation,
        organisationName,
        organisationUuidIn,
        pdfGenerationTemplate,
        readDepth,
        search,
        status,
        subscriptionId,
        tags,
        tcnAllowedCampaignCollectorTypes,
        tcnScheduleTemplateId,
        templateFlow,
        templateFlowUuidIn,
        templateType,
        thumbnail,
        type,
        useBeta,
        useCase,
        uuid,
    }: {
        requestBody: Array<GlobalFlowSerializerWithRepr>,
        applicationType?: Array<string>,
        betaVersion?: Array<string>,
        campaignUuid?: Array<string>,
        channelConfig?: Array<string>,
        complianceType?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        dashboardConfig?: Array<string>,
        debtCollectionsUsecase?: Array<string>,
        deletedBy?: Array<string>,
        demoConfig?: Array<string>,
        demoLeads?: Array<string>,
        deployedVersion?: Array<string>,
        documentation?: Array<string>,
        excludeFields?: Array<string>,
        experimentEnabled?: Array<string>,
        experimentPlatformConfig?: Array<string>,
        experimentVersion?: Array<string>,
        experimentVersions?: Array<string>,
        fields?: Array<string>,
        forDemo?: Array<string>,
        industrySegmentType?: Array<string>,
        isLlm?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        misReportsJson?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        organisation?: Array<string>,
        organisationName?: Array<string>,
        organisationUuidIn?: Array<string>,
        pdfGenerationTemplate?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        subscriptionId?: Array<string>,
        tags?: Array<string>,
        tcnAllowedCampaignCollectorTypes?: Array<string>,
        tcnScheduleTemplateId?: Array<string>,
        templateFlow?: Array<string>,
        templateFlowUuidIn?: Array<string>,
        templateType?: Array<string>,
        thumbnail?: Array<string>,
        type?: Array<string>,
        useBeta?: Array<string>,
        useCase?: Array<string>,
        uuid?: Array<string>,
    }): CancelablePromise<PaginatedGlobalFlowSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/flows/',
            query: {
                'application_type': applicationType,
                'beta_version': betaVersion,
                'campaign_uuid': campaignUuid,
                'channel_config': channelConfig,
                'compliance_type': complianceType,
                'created_at': createdAt,
                'created_by': createdBy,
                'dashboard_config': dashboardConfig,
                'debt_collections_usecase': debtCollectionsUsecase,
                'deleted_by': deletedBy,
                'demo_config': demoConfig,
                'demo_leads': demoLeads,
                'deployed_version': deployedVersion,
                'documentation': documentation,
                'exclude-fields': excludeFields,
                'experiment_enabled': experimentEnabled,
                'experiment_platform_config': experimentPlatformConfig,
                'experiment_version': experimentVersion,
                'experiment_versions': experimentVersions,
                'fields': fields,
                'for_demo': forDemo,
                'industry_segment_type': industrySegmentType,
                'is_llm': isLlm,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'mis_reports_json': misReportsJson,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'organisation': organisation,
                'organisation__name': organisationName,
                'organisation__uuid__in': organisationUuidIn,
                'pdf_generation_template': pdfGenerationTemplate,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'subscription_id': subscriptionId,
                'tags': tags,
                'tcn_allowed_campaign_collector_types': tcnAllowedCampaignCollectorTypes,
                'tcn_schedule_template_id': tcnScheduleTemplateId,
                'template_flow': templateFlow,
                'template_flow__uuid__in': templateFlowUuidIn,
                'template_type': templateType,
                'thumbnail': thumbnail,
                'type': type,
                'use_beta': useBeta,
                'use_case': useCase,
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedGlobalFlowSerializerWithReprList
     * @throws ApiError
     */
    public static flowBulkPartialUpdate({
        requestBody,
        applicationType,
        betaVersion,
        campaignUuid,
        channelConfig,
        complianceType,
        createdAt,
        createdBy,
        dashboardConfig,
        debtCollectionsUsecase,
        deletedBy,
        demoConfig,
        demoLeads,
        deployedVersion,
        documentation,
        excludeFields,
        experimentEnabled,
        experimentPlatformConfig,
        experimentVersion,
        experimentVersions,
        fields,
        forDemo,
        industrySegmentType,
        isLlm,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        misReportsJson,
        name,
        offset,
        ordering,
        organisation,
        organisationName,
        organisationUuidIn,
        pdfGenerationTemplate,
        readDepth,
        search,
        status,
        subscriptionId,
        tags,
        tcnAllowedCampaignCollectorTypes,
        tcnScheduleTemplateId,
        templateFlow,
        templateFlowUuidIn,
        templateType,
        thumbnail,
        type,
        useBeta,
        useCase,
        uuid,
    }: {
        requestBody: Array<GlobalFlowSerializerWithRepr>,
        applicationType?: Array<string>,
        betaVersion?: Array<string>,
        campaignUuid?: Array<string>,
        channelConfig?: Array<string>,
        complianceType?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        dashboardConfig?: Array<string>,
        debtCollectionsUsecase?: Array<string>,
        deletedBy?: Array<string>,
        demoConfig?: Array<string>,
        demoLeads?: Array<string>,
        deployedVersion?: Array<string>,
        documentation?: Array<string>,
        excludeFields?: Array<string>,
        experimentEnabled?: Array<string>,
        experimentPlatformConfig?: Array<string>,
        experimentVersion?: Array<string>,
        experimentVersions?: Array<string>,
        fields?: Array<string>,
        forDemo?: Array<string>,
        industrySegmentType?: Array<string>,
        isLlm?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        misReportsJson?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        organisation?: Array<string>,
        organisationName?: Array<string>,
        organisationUuidIn?: Array<string>,
        pdfGenerationTemplate?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        subscriptionId?: Array<string>,
        tags?: Array<string>,
        tcnAllowedCampaignCollectorTypes?: Array<string>,
        tcnScheduleTemplateId?: Array<string>,
        templateFlow?: Array<string>,
        templateFlowUuidIn?: Array<string>,
        templateType?: Array<string>,
        thumbnail?: Array<string>,
        type?: Array<string>,
        useBeta?: Array<string>,
        useCase?: Array<string>,
        uuid?: Array<string>,
    }): CancelablePromise<PaginatedGlobalFlowSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/flows/',
            query: {
                'application_type': applicationType,
                'beta_version': betaVersion,
                'campaign_uuid': campaignUuid,
                'channel_config': channelConfig,
                'compliance_type': complianceType,
                'created_at': createdAt,
                'created_by': createdBy,
                'dashboard_config': dashboardConfig,
                'debt_collections_usecase': debtCollectionsUsecase,
                'deleted_by': deletedBy,
                'demo_config': demoConfig,
                'demo_leads': demoLeads,
                'deployed_version': deployedVersion,
                'documentation': documentation,
                'exclude-fields': excludeFields,
                'experiment_enabled': experimentEnabled,
                'experiment_platform_config': experimentPlatformConfig,
                'experiment_version': experimentVersion,
                'experiment_versions': experimentVersions,
                'fields': fields,
                'for_demo': forDemo,
                'industry_segment_type': industrySegmentType,
                'is_llm': isLlm,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'mis_reports_json': misReportsJson,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'organisation': organisation,
                'organisation__name': organisationName,
                'organisation__uuid__in': organisationUuidIn,
                'pdf_generation_template': pdfGenerationTemplate,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'subscription_id': subscriptionId,
                'tags': tags,
                'tcn_allowed_campaign_collector_types': tcnAllowedCampaignCollectorTypes,
                'tcn_schedule_template_id': tcnScheduleTemplateId,
                'template_flow': templateFlow,
                'template_flow__uuid__in': templateFlowUuidIn,
                'template_type': templateType,
                'thumbnail': thumbnail,
                'type': type,
                'use_beta': useBeta,
                'use_case': useCase,
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static flowBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/flows/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns FlowView
     * @throws ApiError
     */
    public static flowsRetrieve({
        flowUuid,
    }: {
        flowUuid: string,
    }): CancelablePromise<FlowView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/flows/{flow_uuid}/',
            path: {
                'flow_uuid': flowUuid,
            },
        });
    }
    /**
     * @returns GlobalFlowSerializerWithRepr
     * @throws ApiError
     */
    public static flowsUpdate({
        flowUuid,
        requestBody,
    }: {
        flowUuid: string,
        requestBody: GlobalFlowSerializerWithRepr,
    }): CancelablePromise<GlobalFlowSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/flows/{flow_uuid}/',
            path: {
                'flow_uuid': flowUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns GlobalFlowSerializerWithRepr
     * @throws ApiError
     */
    public static flowsPartialUpdate({
        flowUuid,
        requestBody,
    }: {
        flowUuid: string,
        requestBody?: PatchedGlobalFlowSerializerWithRepr,
    }): CancelablePromise<GlobalFlowSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/flows/{flow_uuid}/',
            path: {
                'flow_uuid': flowUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static flowsDestroy({
        flowUuid,
    }: {
        flowUuid: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/flows/{flow_uuid}/',
            path: {
                'flow_uuid': flowUuid,
            },
        });
    }
    /**
     * @returns FlowView
     * @throws ApiError
     */
    public static flowsFetchCallCreate({
        flowUuid,
        requestBody,
        ssmlRedact,
    }: {
        flowUuid: string,
        requestBody: FetchCallRequest,
        ssmlRedact?: boolean,
    }): CancelablePromise<FlowView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/flows/{flow_uuid}/fetch_call/',
            path: {
                'flow_uuid': flowUuid,
            },
            query: {
                'ssml_redact': ssmlRedact,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedAccountAttributesList
     * @throws ApiError
     */
    public static flowsGetAccountAttributesList({
        flowUuid,
        applicationType,
        betaVersion,
        campaignUuid,
        channelConfig,
        complianceType,
        createdAt,
        createdBy,
        dashboardConfig,
        debtCollectionsUsecase,
        deletedBy,
        demoConfig,
        demoLeads,
        deployedVersion,
        documentation,
        excludeFields,
        experimentEnabled,
        experimentPlatformConfig,
        experimentVersion,
        experimentVersions,
        fields,
        forDemo,
        industrySegmentType,
        isLlm,
        lastModifiedAt,
        lastModifiedBy,
        limit,
        misReportsJson,
        name,
        offset,
        ordering,
        organisation,
        organisationName,
        organisationUuidIn,
        pdfGenerationTemplate,
        readDepth,
        search,
        status,
        subscriptionId,
        tags,
        tcnAllowedCampaignCollectorTypes,
        tcnScheduleTemplateId,
        templateFlow,
        templateFlowUuidIn,
        templateType,
        thumbnail,
        type,
        useBeta,
        useCase,
        uuid,
    }: {
        flowUuid: string,
        applicationType?: Array<string>,
        betaVersion?: Array<string>,
        campaignUuid?: Array<string>,
        channelConfig?: Array<string>,
        complianceType?: Array<string>,
        createdAt?: Array<string>,
        createdBy?: Array<string>,
        dashboardConfig?: Array<string>,
        debtCollectionsUsecase?: Array<string>,
        deletedBy?: Array<string>,
        demoConfig?: Array<string>,
        demoLeads?: Array<string>,
        deployedVersion?: Array<string>,
        documentation?: Array<string>,
        excludeFields?: Array<string>,
        experimentEnabled?: Array<string>,
        experimentPlatformConfig?: Array<string>,
        experimentVersion?: Array<string>,
        experimentVersions?: Array<string>,
        fields?: Array<string>,
        forDemo?: Array<string>,
        industrySegmentType?: Array<string>,
        isLlm?: Array<string>,
        lastModifiedAt?: Array<string>,
        lastModifiedBy?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        misReportsJson?: Array<string>,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        organisation?: Array<string>,
        organisationName?: Array<string>,
        organisationUuidIn?: Array<string>,
        pdfGenerationTemplate?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        status?: Array<string>,
        subscriptionId?: Array<string>,
        tags?: Array<string>,
        tcnAllowedCampaignCollectorTypes?: Array<string>,
        tcnScheduleTemplateId?: Array<string>,
        templateFlow?: Array<string>,
        templateFlowUuidIn?: Array<string>,
        templateType?: Array<string>,
        thumbnail?: Array<string>,
        type?: Array<string>,
        useBeta?: Array<string>,
        useCase?: Array<string>,
        uuid?: Array<string>,
    }): CancelablePromise<PaginatedAccountAttributesList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/flows/{flow_uuid}/get_account_attributes/',
            path: {
                'flow_uuid': flowUuid,
            },
            query: {
                'application_type': applicationType,
                'beta_version': betaVersion,
                'campaign_uuid': campaignUuid,
                'channel_config': channelConfig,
                'compliance_type': complianceType,
                'created_at': createdAt,
                'created_by': createdBy,
                'dashboard_config': dashboardConfig,
                'debt_collections_usecase': debtCollectionsUsecase,
                'deleted_by': deletedBy,
                'demo_config': demoConfig,
                'demo_leads': demoLeads,
                'deployed_version': deployedVersion,
                'documentation': documentation,
                'exclude-fields': excludeFields,
                'experiment_enabled': experimentEnabled,
                'experiment_platform_config': experimentPlatformConfig,
                'experiment_version': experimentVersion,
                'experiment_versions': experimentVersions,
                'fields': fields,
                'for_demo': forDemo,
                'industry_segment_type': industrySegmentType,
                'is_llm': isLlm,
                'last_modified_at': lastModifiedAt,
                'last_modified_by': lastModifiedBy,
                'limit': limit,
                'mis_reports_json': misReportsJson,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'organisation': organisation,
                'organisation__name': organisationName,
                'organisation__uuid__in': organisationUuidIn,
                'pdf_generation_template': pdfGenerationTemplate,
                'read_depth': readDepth,
                'search': search,
                'status': status,
                'subscription_id': subscriptionId,
                'tags': tags,
                'tcn_allowed_campaign_collector_types': tcnAllowedCampaignCollectorTypes,
                'tcn_schedule_template_id': tcnScheduleTemplateId,
                'template_flow': templateFlow,
                'template_flow__uuid__in': templateFlowUuidIn,
                'template_type': templateType,
                'thumbnail': thumbnail,
                'type': type,
                'use_beta': useBeta,
                'use_case': useCase,
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns FlowView
     * @throws ApiError
     */
    public static flowsTriggerCallCreate({
        flowUuid,
        requestBody,
    }: {
        flowUuid: string,
        requestBody: TriggerCallRequest,
    }): CancelablePromise<FlowView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/flows/{flow_uuid}/trigger_call/',
            path: {
                'flow_uuid': flowUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static flowsUpgradeToPublicUpdate({
        flowUuid,
    }: {
        flowUuid: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/flows/{flow_uuid}/upgrade_to_public/',
            path: {
                'flow_uuid': flowUuid,
            },
        });
    }
    /**
     * @returns TemplateValidationResponse
     * @throws ApiError
     */
    public static flowsValidateExpressionCreate({
        flowUuid,
        requestBody,
    }: {
        flowUuid: string,
        requestBody: TemplateValidation,
    }): CancelablePromise<TemplateValidationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/flows/{flow_uuid}/validate_expression/',
            path: {
                'flow_uuid': flowUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns FlowView
     * @throws ApiError
     */
    public static flowsGetAccountInteractionMessagesByChannelRetrieve({
        accountId,
        channel,
    }: {
        accountId?: string,
        channel?: string,
    }): CancelablePromise<FlowView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/flows/get_account_interaction_messages_by_channel/',
            query: {
                'account_id': accountId,
                'channel': channel,
            },
        });
    }
    /**
     * @returns FlowView
     * @throws ApiError
     */
    public static flowsPostOmnichannelMessageCreate({
        requestBody,
    }: {
        requestBody: PostOmniMessage,
    }): CancelablePromise<FlowView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/flows/post_omnichannel_message/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
